<template>
    <div class="c-404">
        <div class="head-box"><navBar :isNav2="true"></navBar></div>
        <div class="content">
            <!-- 面包屑 -->
            <div class="breadbox">
                <div class="container1">
                    <div class="f_cont">
                        <router-link to="/">首页</router-link>
                        <span>&gt;</span>
                        <a href="javascript:;">404</a>
                    </div>
                </div>
            </div>
            <!-- 404内容1 -->
            <div class="c-404-1">
                <div class="container1">
                    <img class="c-img" src="../assets/images/404.jpg" alt="" />
                    <p class="c-text font20">糟糕！页面跑丢啦！</p>
                    <router-link to="/" class="but but-blank but-blank-hover understand-details" type="primary" round>
                        返回首页&nbsp;
                        <span class="arrow el-icon-d-arrow-right"></span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from '../components/navBar.vue';
export default {
    name: '',
    data() {
        return {};
    },
    created() {},
    mounted() {
        setTimeout(() => {
            this.setDomAnimate(tagIndex => {
                console.log(tagIndex);
                if (tagIndex == 0) {
                    this.setModuleAnimate('us1Animate', 'animate-fadeInUp-module');
                }
            });
        }, 500);
    },
    computed: {},
    methods: {},
    components: { navBar },
    beforeDestroy() {},
    watch: {}
};
</script>

<style scoped lang="less">
::v-deep .navBar-box {
    z-index: 100;
    background: #fff;
    box-shadow: 0 4px 40px rgba(50, 51, 51, 0.06);
    .navbar .nav-link {
        color: #333333;
    }
    .navbar .right-box .el-dropdown-link,
    .navbar {
        color: #333;
    }
    .navbar .nav-link .arrow {
        background-image: url(../assets/images/arrow-down2.svg);
    }
    .navbar .navbar-toggler .icon-caidan {
        color: #333;
    }
    .navbar .navbar-collapse {
        @media @max-sm {
            position: absolute;
            top: 80px;
            left: 0;
            width: 100%;
            padding: 0 20px;
            background: #fff;
            overflow: hidden;
        }
    }
    .left-box {
        @media @max-sm {
            display: flex;
            align-items: center;
            height: 60px;
        }
    }
}
.breadbox {
    // margin-top: 80px;
}
.c-404 {
    .head-box {
        width: 100%;
        height: 80px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: #ffffff;
    }
    // banner
    // 404内容1
    .c-404-1 {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 60px 0;
        text-align: center;
        min-height: calc(100vh - 80px);
        .c-img {
            width: 100%;
            max-width: 595px;
        }
        .c-text {
            margin: 60px 0;
        }
        .but {
            display: inline-block;
            color: #fff;
            background-color: #eb5405;
            padding: 16px 40px;
            font-size: 16px;
            border: none;
            border-radius: 35px;
            transition: all 0.3s;
            @media @max-xs {
                padding: 10px 15px;
            }
        }
        .but-blank {
            border: thin solid #eb5405;
        }
    }
}
</style>
